import React, { MouseEvent, ReactElement, useEffect } from 'react';

import { Wrapper } from './Pagination.styles';

type Props = {
  pageCount: number;
  activePage: number;
  setActivePage(page: number): void;
  pageStartIndex: number;
  setPageStartIndex(page: number | Function): void;
};

const Pagination = ({
  pageCount,
  activePage,
  setActivePage,
  pageStartIndex,
  setPageStartIndex,
}: Props): ReactElement => {
  const paginationRange = [...Array(pageCount + 1)].map((_, i) => i).slice(pageStartIndex, pageStartIndex + 3);

  const handleClickPage = (e: MouseEvent<HTMLButtonElement>, page: number): void => {
    e.preventDefault();
    setActivePage(page);
  };

  useEffect(() => {
    setPageStartIndex(Math.max(activePage - (activePage === pageCount ? 2 : 1), 1));
  }, [activePage, pageCount, pageStartIndex, setPageStartIndex]);

  if (pageCount <= 1) {
    return <></>;
  }

  return (
    <Wrapper>
      <nav aria-label="page navigation" className="navigation">
        <ul className="pagination">
          {activePage > 1 && (
            <li className={`page-item`} key={'prev'}>
              <button className="page-link" onClick={(e) => handleClickPage(e, activePage - 1)}>
                &larr;
              </button>
            </li>
          )}
          {paginationRange.map((page) => (
            <li className={`page-item ${page === activePage ? 'active' : ''}`} key={page}>
              <button className="page-link" onClick={(e) => handleClickPage(e, page)}>
                {page}
              </button>
            </li>
          ))}
          {activePage < pageCount && (
            <li className={`page-item`} key={'next'}>
              <button className="page-link" onClick={(e) => handleClickPage(e, activePage + 1)}>
                &rarr;
              </button>
            </li>
          )}
        </ul>
        <span className="pagination-info">
          Page {activePage} of {pageCount}
        </span>
      </nav>
    </Wrapper>
  );
};

export default Pagination;
